import { useAppSelector, useOpen } from "@/app/hooks";
import BurgerMenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Drawer,
  IconButton,
  MenuItem,
  Stack,
  useMediaQuery,
} from "@mui/material";
import getNavData from "./nav-data";
import { Link, useLocation } from "react-router-dom";

export const HeaderBurger = () => {
  const { open, setOpen } = useOpen();
  const { isAuthenticated, cabinetType } = useAppSelector(
    (state) => state.auth
  );
  const isMobile = useMediaQuery("(max-width: 960px)");
  const { pathname } = useLocation();

  const navData = getNavData();

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  if (!isMobile) return null;

  return (
    <>
      <IconButton onClick={onOpen}>
        <BurgerMenuIcon />
      </IconButton>

      <Drawer open={open} onClose={onClose}>
        <Box>
          <IconButton
            onClick={onClose}
            sx={{
              mt: "15px",
              ml: "16px",
            }}
          >
            <BurgerMenuIcon />
          </IconButton>
        </Box>

        <Stack mt={2}>
          {navData
            .filter(
              (el) =>
                !el.condition ||
                el.condition({
                  isAuthenticated,
                  cabinetType,
                  pathname,
                })
            )
            .map((el, idx) => {
              if (!el.isLanding && pathname === "/") return null;
              if (el.isLanding && pathname !== "/") return null;

              const isActive = pathname.includes(el.to);
              const isAnchor = el.to.startsWith("#");

              return (
                <MenuItem
                  {...(isAnchor
                    ? {
                        component: "a",
                        href: el.to,
                      }
                    : {
                        component: Link,
                        to: el.to,
                      })}
                  onClick={onClose}
                  key={idx}
                  sx={{
                    backgroundColor: isActive ? "primary.light" : "transparent",
                  }}
                >
                  {el.label}
                </MenuItem>
              );
            })}
        </Stack>
      </Drawer>
    </>
  );
};
